<template>
  <div class="cdkey-container">
    <!-- 添加 Toast 组件 -->
    <ToastNotification
      v-if="showToast"
      v-bind="toastConfig"
      @close="showToast = false"
    />
    <!-- 导航栏 -->
    <div class="nav-tabs">
      <button
        :class="['nav-tab', { active: currentView === 'list' }]"
        @click="currentView = 'list'"
      >
        兑换 CDKey
      </button>
      <button
        :class="['nav-tab', { active: currentView === 'query' }]"
        @click="currentView = 'query'"
      >
        查询 CDKey
      </button>
    </div>

    <!-- 兑换部分 -->
    <template v-if="currentView === 'list'">
      <!-- 游戏列表视图 -->
      <div v-if="!selectedGame" class="game-list">
        <div
          v-for="game in games"
          :key="game.id"
          class="game-card"
          @click="selectGame(game)"
        >
          <img :src="game.image" :alt="game.title" class="game-image" />
          <div class="game-info">
            <h3>{{ game.title }}</h3>
            <div class="game-stats">
              <span>Cdkey 兑换领取</span>
            </div>
          </div>
        </div>
      </div>

      <!-- CDKey兑换表单 -->
      <div v-else class="redeem-form">
        <div class="back-button" @click="selectedGame = null">
          <i class="fas fa-arrow-left"></i>
          <span>返回游戏列表</span>
        </div>

        <div v-if="!gameConfig">
          <p class="error-message">该游戏暂未配置兑换功能</p>
        </div>

        <template v-else>
          <!-- 添加游戏标题 -->
          <div class="game-title">
            <img
              :src="selectedGame.image"
              :alt="selectedGame.title"
              class="game-title-image"
            />
            <h2 class="game-title-text">{{ selectedGame.title }}</h2>
          </div>

          <!-- 登录方式选择 -->
          <div class="login-methods" v-if="gameConfig.loginMethods.length > 1">
            <div class="form-group">
              <label>登录方式</label>
              <div class="login-method-buttons">
                <button
                  v-for="method in gameConfig.loginMethods"
                  :key="method.id"
                  :class="[
                    'method-btn',
                    { active: selectedLoginMethod === method.id },
                  ]"
                  @click="selectLoginMethod(method.id)"
                >
                  {{ method.name }}
                </button>
              </div>
            </div>
          </div>

          <!-- 动态表单 -->
          <form
            v-if="currentLoginMethod"
            @submit.prevent="handleSubmit"
            class="form-content"
          >
            <template v-for="field in currentFields" :key="field.name">
              <div class="form-group">
                <label>{{ field.label }}</label>
                <!-- 判断是否需要显示验证码按钮 -->
                <div v-if="field.hasVerificationCode" class="input-group">
                  <input
                    :type="field.type"
                    v-model="formData[field.name]"
                    :placeholder="field.placeholder"
                    :required="field.required"
                  />
                  <button
                    type="button"
                    class="verification-code-btn"
                    :disabled="isVerificationCodeLoading"
                    @click="sendVerificationCode"
                  >
                    {{ verificationCodeText }}
                  </button>
                </div>
                <!-- CDKey输入框 - 根据URL参数决定是否禁用 -->
                <input
                  v-else-if="field.name === 'cdkey'"
                  :type="field.type"
                  v-model="formData[field.name]"
                  :placeholder="field.placeholder"
                  :required="field.required"
                  :disabled="cdkFromUrl"
                  :class="{ 'input-disabled': cdkFromUrl }"
                />
                <!-- 普通输入框 -->
                <input
                  v-else
                  :type="field.type"
                  v-model="formData[field.name]"
                  :placeholder="field.placeholder"
                  :required="field.required"
                />
              </div>
            </template>

            <button
              type="submit"
              class="submit-btn"
              :disabled="isButtonDisabled"
              :class="{ loading: isSubmitting || isLoading }"
            >
              <span class="btn-content">
                <span class="spinner" v-if="isSubmitting || isLoading"></span>
                <span class="btn-text">{{ submitButtonText }}</span>
              </span>
            </button>
          </form>
        </template>
      </div>
    </template>

    <!-- 查询部分 -->
    <div v-if="currentView === 'query'" class="redeem-form">
      <form @submit.prevent="handleQuery" class="form-content">
        <div class="form-group">
          <label>CDKey</label>
          <input
            type="text"
            v-model="queryData.cdkey"
            placeholder="请输入要查询的CDKey"
            required
          />
        </div>

        <button
          type="submit"
          class="submit-btn"
          :disabled="isQueryLoading"
          :class="{ loading: isQueryLoading }"
        >
          <span class="btn-content">
            <span class="spinner" v-if="isQueryLoading"></span>
            <span class="btn-text">{{
              isQueryLoading ? "查询中..." : "查询"
            }}</span>
          </span>
        </button>
      </form>

      <!-- 查询结果 -->
      <div v-if="queryResult" class="query-result">
        <div class="result-item">
          <label>CDKey状态：</label>
          <span
            :class="[
              'status',
              queryResult.status === 'unused' ? 'status-unused' : 'status-used',
            ]"
          >
            {{ queryResult.status === "unused" ? "未使用" : "已使用" }}
          </span>
        </div>
        <div class="result-item">
          <label>游戏名称：</label>
          <span>{{ queryResult.game }}</span>
        </div>
        <div v-if="queryResult.status === 'used'" class="result-item">
          <label>使用时间：</label>
          <span>{{ queryResult.usedTime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToastNotification from "@/components/common/ToastNotification.vue";
import { GAME_CONFIGS } from "@/config/games";
import { mockCDKeyService } from "@/mocks/cdkeyService";
export default {
  name: "CDKeyRedemption",
  data() {
    return {
      currentView: "list",
      selectedGame: null,
      games: [
        {
          id: "pubg",
          en_title: "PUBG: BATTLEGROUNDS",
          title: "绝地求生",
          image: "/cdk/pubg.png",
          drops: 11,
          rewards: 33,
        },
        {
          id: "rust",
          title: "Rust",
          image: "/cdk/rust.jpg",
          drops: 2,
          rewards: 5,
        },
        {
          id: "rainbow-six-sixge",
          title: "Rainbow Six Sixge",
          image: "/cdk/rainbow-six-siege.jpg",
          drops: 2,
          rewards: 5,
        },
        {
          id: "hunt-showdown",
          title: "Hunt: showdown",
          image: "/cdk/hunt-showdown.jpg",
        },
        {
          id: "party-animals",
          title: "Party Animals",
          image: "/cdk/party-animals.jpg",
          drops: 1,
          rewards: 1,
        },
        {
          id: "soulframe",
          title: "Soulframe",
          image: "/cdk/sf_2.webp",
          // image: "/cdk/sf-1.webp",
          // image: "/cdk/SF_Masthead_new.webm",
          // image: "/cdk/mobile_sf.webm",
          drops: 9,
          rewards: 8,
        },
          {
          id: "warframe",
          title: "Warframe",
          image: "/cdk/squad.png",
          drops: 9,
          rewards: 8,
        },
      ],
      formData: {
        username: "",
        password: "",
        cdkey: "",
      },
      queryData: {
        cdkey: "",
      },
      queryResult: null,
      // 新增 toast 相关状态
      showToast: false,
      toastConfig: {
        type: "success",
        title: "",
        message: "",
        duration: 3000,
      },
      isLoading: false,
      isQueryLoading: false,
      selectedLoginMethod: null,
      verificationCodeText: "获取验证码",
      verificationCodeTimer: null,
      isVerificationCodeLoading: false,
      // formData: {},
      requiredExtraFields: [], // 存储需要额外填写的字段
      verificationStep: "initial", // 验证步骤：initial, verifying, verified
      hasExtraFields: false, // 添加这个标记来表示是否需要额外字段
      isSubmitting: false, // 添加专门的提交状态标记
      cdkFromUrl: false, // 标记CDKey是否来自URL参数
    };
  },
  components: {
    ToastNotification,
  },
  methods: {
    showNotification(config) {
      // 默认配置
      this.toastConfig = {
        type: "info", // 默认类型为 info
        title: "", // 默认无标题
        message: "", // 默认无消息
        duration: 3000, // 默认显示 3 秒
        autoClose: true, // 默认自动关闭
      };

      // 使用传入的配置覆盖默认配置
      this.toastConfig = { ...this.toastConfig, ...config };
      this.showToast = true;
    },
    selectGame(game) {
      this.selectedGame = game;
      this.formData = {}; // 清空表单数据

      // 如果有URL中的CDKey参数，填入表单
      if (this.$route.query.code) {
        this.formData.cdkey = this.$route.query.code;
        this.cdkFromUrl = true;
      }

      if (this.gameConfig?.loginMethods?.length > 0) {
        // 默认选择第一个登录方式
        this.selectedLoginMethod = this.gameConfig.loginMethods[0].id;
      } else {
        this.selectedLoginMethod = null;
      }
    },

    selectLoginMethod(methodId) {
      this.selectedLoginMethod = methodId;
      this.formData = {}; // 切换登录方式时清空表单

      // 如果有URL中的CDKey参数，重新填入表单
      if (this.$route.query.code) {
        this.formData.cdkey = this.$route.query.code;
        this.cdkFromUrl = true;
      }
    },

    // 从URL解析参数并自动选择游戏
    processUrlParams() {
      const { code, game } = this.$route.query;

      if (code) {
        this.formData.cdkey = code;
        this.cdkFromUrl = true;
      }

      if (game) {
        // 根据game参数找到对应的游戏
        const gameObj = this.games.find(
          (g) => g.id.toLowerCase() === game.toLowerCase()
        );
        if (gameObj) {
          this.selectGame(gameObj);
        }
      }
    },

    async sendVerificationCode() {
      if (this.isVerificationCodeLoading) return;

      try {
        this.isVerificationCodeLoading = true;
        // 这里添加发送验证码的API调用
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // 开始倒计时
        let countdown = 60;
        this.verificationCodeText = `${countdown}s后重新获取`;

        this.verificationCodeTimer = setInterval(() => {
          countdown--;
          if (countdown <= 0) {
            clearInterval(this.verificationCodeTimer);
            this.verificationCodeText = "获取验证码";
            this.isVerificationCodeLoading = false;
          } else {
            this.verificationCodeText = `${countdown}s后重新获取`;
          }
        }, 1000);

        this.showNotification({
          type: "success",
          title: "发送成功",
          message: "验证码已发送到您的邮箱",
        });
      } catch (error) {
        this.showNotification({
          type: "error",
          title: "发送失败",
          message: error.message || "请稍后重试",
        });
      }
    },

    // 验证特定登录方式的表单
    validateForm() {
      const method = this.currentLoginMethod;
      if (!method) return false;

      // 只验证当前登录方式所需的字段
      const requiredFields = method.fields.filter((field) => field.required);
      for (const field of requiredFields) {
        if (!this.formData[field.name]) {
          this.showNotification({
            type: "error",
            title: "表单错误",
            message: `请填写${field.label}`,
          });
          return false;
        }
      }

      return true;
    },

    async handleQuery() {
      if (!this.queryData.cdkey) {
        this.showNotification({
          type: "error",
          title: "查询错误",
          message: "请输入CDKey",
        });
        return;
      }

      try {
        this.isQueryLoading = true;

        // 构造查询URL
        const queryUrl = `/api/twitch/cdkey/query?cdk=${encodeURIComponent(
          this.queryData.cdkey
        )}`;

        const response = await fetch(queryUrl);
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "查询失败");
        }

        // 处理返回结果
        if (data.success) {
          this.queryResult = {
            status:
              data.status === 0 && data.message.includes("已经使用")
                ? "used"
                : "unused",
            game: data.data?.game_id || "",
            usedTime: data.data?.used_at || "Unknown",
          };

          this.showNotification({
            type: "info",
            title: "查询结果",
            message:
              data.message ||
              `CDKey 状态：${
                this.queryResult.status === "used" ? "已使用" : "未使用"
              }`,
            duration: 5000,
          });
        } else {
          throw new Error(data.message || "查询失败");
        }
      } catch (error) {
        this.showNotification({
          type: "error",
          title: "查询失败",
          message: error.message || "请稍后重试",
          duration: 5000,
        });
      } finally {
        this.isQueryLoading = false;
      }
    },

    // 新增轮询查询方法
    async startPolling(api, login_id) {
      let attempts = 0;
      const maxAttempts = 100;
      const interval = 5000;
      let pollingInterval = null;

      return new Promise((resolve, reject) => {
        const pollQuery = async () => {
          if (attempts >= maxAttempts) {
            clearInterval(pollingInterval);
            reject(new Error("查询次数达到上限，请重试"));
            return;
          }

          try {
            const queryUrl = `${api}?job_id=${encodeURIComponent(login_id)}`;
            const response = await fetch(queryUrl);
            const data = await response.json();

            attempts++;

            if (data.success) {
              const status = data?.data?.status;

              if (status === "finished") {
                clearInterval(pollingInterval);
                resolve(data);
                return;
              } else if (status === "fail") {
                clearInterval(pollingInterval);
                reject(new Error(data?.data?.message || "登录失败"));
                return;
              }
            } else {
              // API 调用失败
              // 可以选择继续轮询或立即终止
              // 如果要立即终止，取消注释下面的代码
              clearInterval(pollingInterval);
              reject(new Error(data.message || "查询失败"));
              return;
            }
          } catch (error) {
            clearInterval(pollingInterval);
            console.error("查询出错:", error);
            reject(error);
          }
        };

        // 立即执行第一次查询
        pollQuery();
        pollingInterval = setInterval(pollQuery, interval);
      });
    },

    // 修改提交处理方法
    async handleSubmit() {
      // 判断是否需要验证
      localStorage.setItem("login_id", null);
      if (
        this.currentLoginMethod?.verify &&
        this.verificationStep === "initial"
      ) {
        const verified = await this.verifyCredentials();
        if (!verified) return;

        if (this.hasExtraFields) return;
      }

      // 验证表单
      if (!this.validateForm()) {
        return;
      }
      try {
        this.isSubmitting = true;

        // 获取当前登录方式的提交配置
        const { api, transformData } = this.currentLoginMethod.submit;
        const submitData = transformData(this.formData);

        var result;

        if (
          this.selectedGame.id == "pubg" &&
          this.currentLoginMethod.id == "krafton"
        ) {
          const login_id = localStorage.getItem("login_id");
          // 循环查询这个login_id直达票成功、构造result，进行领取
          // 开始轮询查询
          const result_data = await this.startPolling(api, login_id);

          if (
            result_data == null ||
            result_data.data == null ||
            result_data.data.login_id == null
          ) {
            throw new Error(result_data.messsage);
          }

          localStorage.setItem("login_id", result_data?.data.login_id);
          result = {
            success: result_data.success,
            message: result_data.message,
            login_id: result_data?.data.login_id,
          };
        } else {
          const response = await fetch(api, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(submitData),
          });

          result = await response.json();
        }

        // ... 处理响应的代码（与之前的相同）

        if (this.verificationStep == "verified" || result.success) {
          // 调用领取 API
          const claimResult = await this.cdkClaim();
          if (claimResult.success) {
            this.showNotification({
              type: "success",
              title: "兑换成功",
              duration: 10000,
              autoClose: false,
              message:
                claimResult.message ||
                result.message ||
                `${this.selectedGame.title} CDKey 已成功兑换！`,
            });
          } else {
            this.showNotification({
              type: "error",
              title: "兑换失败",
              duration: 10000,
              autoClose: true,
              message:
                claimResult.message ||
                result.message ||
                `${this.selectedGame.title} CDKey 兑换失败！`,
            });
          }

          this.resetForm();
        } else {
          this.showNotification({
            type: "info",
            title: "验证失败",
            message: result.message || "验证失败！请使用稳定网络！",
          });
        }
      } catch (error) {
        // 处理网络错误或其他异常
        this.showNotification({
          type: "error",
          title: "兑换失败",
          message: error.message || "请稍后重试",
          duration: 5000,
        });

        // 如果是网络错误，可能需要特殊处理
        if (error instanceof TypeError && error.message === "Failed to fetch") {
          this.showNotification({
            type: "error",
            title: "网络错误",
            message: "请检查网络连接后重试",
            duration: 5000,
          });
        }
      } finally {
        this.isSubmitting = false;
      }
    },

    // 添加重置表单的方法
    resetForm() {
      this.formData = {};
      this.verificationStep = "initial";
      this.hasExtraFields = false;
      this.requiredExtraFields = [];
      this.isSubmitting = false;
      this.isLoading = false;

      // 如果有URL中的CDKey参数，重新填入表单
      if (this.$route.query.code) {
        this.formData.cdkey = this.$route.query.code;
        this.cdkFromUrl = true;
      } else {
        this.cdkFromUrl = false;
      }
    },

    // 修改表单验证方法
    validateForm() {
      const method = this.currentLoginMethod;
      if (!method) return false;

      // 验证基础字段
      for (const field of this.currentLoginMethod.fields) {
        if (field.required && !this.formData[field.name]) {
          this.showNotification({
            type: "error",
            title: "表单错误",
            message: `请填写${field.label}`,
          });
          return false;
        }
      }

      // 如果需要额外字段，验证额外字段
      if (this.hasExtraFields) {
        for (const fieldName of this.requiredExtraFields) {
          const extraField = this.currentLoginMethod.extraFields[fieldName];
          if (extraField?.required && !this.formData[fieldName]) {
            this.showNotification({
              type: "error",
              title: "表单错误",
              message: `请填写${extraField.label}`,
            });
            return false;
          }
        }
      }

      return true;
    },

    async verifyCredentials() {
      const method = this.currentLoginMethod;
      if (!method?.verify) return true;

      try {
        this.verificationStep = "verifying";
        this.isLoading = true;

        const { api, transformData } = method.verify;
        const verifyData = transformData(this.formData);

        const response = await fetch(api, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(verifyData),
        });

        const result = await response.json();

        // pubg的akm登陆方式
        if (this.selectedGame.id == "pubg" && method.id == "krafton") {
          if (
            result == null ||
            result.data == null ||
            result?.data.login_id == null
          ) {
            throw new Error(result.message);
          }
          if (result?.data.login_id != undefined) {
            localStorage.setItem("login_id", result.data.login_id);
          }
        }

        if (!response.ok) {
          switch (response.status) {
            case 403:
              // 需要额外验证
              if (result.required_fields?.length > 0) {
                this.requiredExtraFields = result.required_fields;
                this.hasExtraFields = true;
                // 重置验证状态为"需要验证"而不是保持"验证中"
                this.verificationStep = "needExtra";
                this.showNotification({
                  type: "info",
                  title: "需要验证",
                  message: result.message || "请完成额外验证",
                  duration: 5000,
                });
                return true;
              }
              break;
            default:
              throw new Error(result.message || "验证失败");
          }
        }

        // 如果验证通过且不需要额外验证
        this.verificationStep = "verified";
        return true;
      } catch (error) {
        this.showNotification({
          type: "error",
          title: "验证失败",
          message: error.message || "请检查账号密码是否正确",
          duration: 5000,
        });
        this.verificationStep = "initial";
        return false;
      } finally {
        this.isLoading = false;
      }
    },

    // 对于每个的领取
    async cdkClaim() {
      // 获取当前登录方式的领取接口信息
      const { api, transformData } = this.currentLoginMethod.claim;
      const submitData = transformData(this.formData);

      console.log(this.selectedGame.id);
      console.log(this.currentLoginMethod);
      // console.log()
      // FIXME 这里可以直接注释掉这个if，使用 akm登录方式
      if (
        this.selectedGame.id == "soulframe"
      ) {
        this.showNotification({
          type: "info",
          title: "领取提示",
          message: "请确认账号密码正确无误!",
          duration: 3000,
          autoClose: false,
        });
        await new Promise((resolve) => setTimeout(resolve, 3000));
        this.showNotification({
          type: "info",
          title: "领取提示",
          message: "正在兑换领取，请耐心等待!",
          duration: 3000,
          autoClose: false,
        });
        await new Promise((resolve) => setTimeout(resolve, 3000));
        const result = {
            success: true,
            message: "已成功提交、请稍后检查仓库!"
        }
        return result
      }
      if (
        this.selectedGame.id == "pubg" &&
        this.currentLoginMethod.id == "krafton"
      ) {
        const job_id = localStorage.getItem("login_id");
        if (job_id) {
          submitData.job_id = job_id;
          submitData.username = this.formData.world_username;
        }
      }

      this.showNotification({
        type: "info",
        title: "领取提示",
        message: "正在兑换领取，请耐心等待!",
        duration: 3000,
        autoClose: false,
      });

      const responseClaim = await fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(submitData),
      });

      const result = await responseClaim.json();
      return result;
    },
    isVideo(url) {
      return /\.(mp4|webm)$/i.test(url)
    },
    getPoster(url) {
      // 你可以根据视频路径规则，自动生成对应的 poster 图路径
      return url.replace(/\.(mp4|webm)$/i, '_Fallback.jpg')
    },
    getVideoSources(url) {
      const base = url.replace(/\.(mp4|webm)$/i, '')
      return [
        {type: 'webm', src: `${base}.webm`},
        {type: 'mp4', src: `${base}.mp4`}
      ]
    }
  },
  computed: {
    gameConfig() {
      // 使用游戏标题来匹配配置
      return this.selectedGame ? GAME_CONFIGS[this.selectedGame.title] : null;
    },
    currentLoginMethod() {
      if (!this.gameConfig?.loginMethods) return null;
      return (
        this.gameConfig.loginMethods.find(
          (method) => method.id === this.selectedLoginMethod
        ) || this.gameConfig.loginMethods[0]
      );
    },
    // 添加当前提交配置的计算属性
    currentSubmitConfig() {
      if (!this.gameConfig?.submit || !this.selectedLoginMethod) return null;
      return this.gameConfig.submit[this.selectedLoginMethod];
    },
    // 获取当前需要显示的所有字段
    currentFields() {
      if (!this.currentLoginMethod) return [];

      const baseFields = [...this.currentLoginMethod.fields];

      // 添加需要的额外字段
      if (
        this.currentLoginMethod.extraFields &&
        this.requiredExtraFields.length > 0
      ) {
        this.requiredExtraFields.forEach((fieldName) => {
          const extraField = this.currentLoginMethod.extraFields[fieldName];
          if (extraField) {
            baseFields.push(extraField);
          }
        });
      }

      return baseFields;
    },

    // 计算按钮显示的文本
    submitButtonText() {
      if (this.isSubmitting) return "兑换中...";
      if (this.verificationStep === "verifying") return "验证中...";
      return "兑换";
    },

    // 计算按钮是否应该禁用
    isButtonDisabled() {
      return (
          this.isSubmitting ||
          this.isLoading ||
          this.verificationStep === "verifying"
      );
    },
  },
  mounted() {
    // 在组件挂载后处理URL参数
    this.processUrlParams();
  },
  beforeDestroy() {
    if (this.verificationCodeTimer) {
      clearInterval(this.verificationCodeTimer);
    }
  },
  watch: {
    // 监听路由变化，以便在URL参数更改时更新组件
    "$route.query": {
      handler() {
        this.processUrlParams();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* 整体容器样式优化 */
.cdkey-container {
  padding: 24px;
  min-height: 100vh;
  background-color: #1a1b26;
  color: #e5e7eb;
}

.game-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.game-card {
  background-color: rgba(36, 39, 58, 0.8);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.game-card:hover {
  transform: translateY(-4px);
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.game-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.game-card:hover .game-image {
  transform: scale(1.05);
}

.game-info {
  padding: 20px;
  background: linear-gradient(
      to bottom,
      rgba(36, 39, 58, 0.8),
      rgba(36, 39, 58, 0.95)
  );
}

.game-stats {
  display: flex;
  gap: 16px;
  color: #9ca3af;
  font-size: 14px;
}

/* 表单样式优化 */
.redeem-form {
  max-width: 480px;
  margin: 0 auto;
  background-color: rgba(36, 39, 58, 0.9);
  border-radius: 16px;
  padding: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

/*
旧版本返回列表按钮样式
.back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  cursor: pointer;
  margin-bottom: 24px;
}

.back-button:hover {
  color: #ffffff;
} */

/* 修改明显的返回游戏列表按钮 */
.back-button {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #e5e7eb;
  cursor: pointer;
  margin-bottom: 24px;
  background-color: rgba(55, 65, 81, 0.5);
  padding: 12px 20px;
  border-radius: 8px;
  border: 1px solid rgba(75, 85, 99, 0.4);
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  width: fit-content;
}

.back-button i {
  font-size: 1.1em;
  transition: transform 0.2s ease-in-out;
}

.back-button:hover {
  color: #ffffff;
  background-color: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.back-button:hover i {
  transform: translateX(-4px);
}

.back-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  color: #9ca3af;
  margin-bottom: 8px;
}

.form-group input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  background-color: rgba(31, 41, 55, 0.7);
  color: #ffffff;
  font-size: 15px;
  transition: all 0.3s ease;
}

/* 添加禁用输入框的样式 */
.form-group input.input-disabled {
  background-color: rgba(31, 41, 55, 0.5);
  border-color: rgba(255, 255, 255, 0.05);
  color: #9ca3af;
  cursor: not-allowed;
}

.form-group input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
  background-color: rgba(31, 41, 55, 0.9);
}

.submit-btn {
  width: 100%;
  padding: 12px;
  background-color: #3b82f6;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.2s;
}

.submit-btn:hover {
  background-color: #2563eb;
}

/* 新增样式 */
.nav-tabs {
  display: flex;
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto 24px;
}

.nav-tab {
  padding: 12px 32px;
  background-color: rgba(36, 39, 58, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #9ca3af;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.nav-tab.active {
  background-color: #3b82f6;
  border-color: rgba(59, 130, 246, 0.5);
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.nav-tab:hover {
  color: #ffffff;
}

.nav-tab:hover:not(.active) {
  background-color: rgba(36, 39, 58, 0.95);
  border-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.query-result {
  margin-top: 24px;
  border-top: 1px solid #374151;
  padding-top: 24px;
}

.result-item {
  margin-bottom: 16px;
  color: #9ca3af;
}

.result-item label {
  color: #ffffff;
  margin-right: 8px;
}

.status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
}

.status-used {
  background-color: #991b1b;
  color: #fecaca;
}

.status-unused {
  background-color: #065f46;
  color: #a7f3d0;
}

/* 兑换按钮 */
/* # 添加新的 CSS 样式： */
/* 按钮加载状态样式 */
.submit-btn {
  position: relative;
  overflow: hidden;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading .btn-text {
  opacity: 0.8;
}

/* 在原有的style中添加 */
.login-methods {
  margin-bottom: 24px;
}

.login-method-buttons {
  display: flex;
  gap: 12px;
  margin-top: 8px;
}

.method-btn {
  padding: 8px 16px;
  background-color: #1f2937;
  border: 1px solid #374151;
  border-radius: 4px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
}

.method-btn.active {
  background-color: #3b82f6;
  border-color: #3b82f6;
  color: #ffffff;
}

.input-group {
  display: flex;
  gap: 12px;
}

.input-group input {
  flex: 1;
}

.verification-code-btn {
  padding: 0 16px;
  background-color: #1f2937;
  border: 1px solid #374151;
  border-radius: 4px;
  color: #9ca3af;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
}

.verification-code-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.verification-code-btn:not(:disabled):hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

/* 在原有的style中添加 */
.game-title {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #374151;
}

.game-title-image {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
}

.game-title-text {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
}

/* 响应式设计优化 */
@media (max-width: 640px) {
  .cdkey-container {
    padding: 16px;
  }

  .game-list {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .nav-tabs {
    flex-direction: column;
    gap: 12px;
  }

  .redeem-form {
    padding: 24px;
    margin: 0 16px;
  }

  .login-method-buttons {
    flex-direction: column;
  }

  .method-btn {
    width: 100%;
    text-align: center;
  }

  .input-group {
    flex-direction: column;
    gap: 8px;
  }

  .verification-code-btn {
    width: 100%;
    padding: 12px;
  }

  .game-title {
    flex-direction: column;
    text-align: center;
  }
}

/* 细节动画优化 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
</style>